
/**
 * Place holder for API calls that will not exist in the new DB.
 * 
 * NOTE: This placeholder is intended to be removed before a production build of 
 * this has been released. If this still exists in production something has gone 
 * wrong.
 * 
 * @returns undefined
 */
export const fakeNoData = async ():Promise<undefined> => {
  return undefined
}